import { Center } from '@mantine/core';
import { handleError } from '@services/errHandler';
import { Component, ReactNode } from 'react';

// Simple error boundary for catching errors in lazy-loaded routes
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean; error: unknown }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error: unknown) {
    return { hasError: true, error };
  }
  componentDidCatch(error: unknown) {
    // Stale chunk hashes after a deploy trigger a reload here instead of a dead-end error page
    handleError(error, 'ErrorBoundary caught error');
  }
  render() {
    if (this.state.hasError) {
      return (
        <Center h="100vh">
          <div style={{ color: 'red', textAlign: 'center' }}>
            <h2>Something went wrong.</h2>
            <pre>{String(this.state.error)}</pre>
          </div>
        </Center>
      );
    }
    return this.props.children;
  }
}
